const Complete = () => {
  return <p>Complete</p>;
};

export default Complete;
